/* eslint-disable max-lines-per-function */
<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="430px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
    >
        <div v-if="progressData.title" slot="title" class="progressTitle">
            {{ progressData.title }}
        </div>
        <div class="custom">
            <span>{{ progressData.state === 0 ? '正在拉取数据中' : progressData.taskName }}</span>
            <el-progress class="mt10" :percentage="progressData.percentage" color="#2770fa" :stroke-width="12" />
            <span class="mt10">{{ progressData.state === 0 ? '正在拉取数据中耐心等待' : progressData.message }}</span>
        </div>
        <div v-if="progressData.taskId" class="mt30">任务ID:{{ progressData.taskId }}</div>
        <span slot="footer" class="dialog-footer">
            <el-button
                v-for="(item, index) in progressData.btnArr"
                :key="index"
                :type="item.type"
                @click="btnHanle(item)"
            >
                {{ item.name }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
let options = {};
let customBtn = false;
let loading;
let loopTimeout = null;
import { encryption } from '../tools.js';
import { cloneDeep } from 'lodash';
export default {
    name: 'ProgressAss',
    data() {
        return {
            dialogVisible: false,
            isOpen: true, // 如果false 就不接收 推送消息
            progressData: {
                title: '进度',
                taskId: '',
                taskName: '正在修改中',
                message: '',
                percentage: 0,
                isFake: false,
                state: 0,
                speed: 15,
                btnArr: [],
                progeressText: '条产品',
            },
            completeCount: 0,
            totalCount: 0,
        };
    },
    watch: {
        'progressData.percentage': {
            handler(percentage) {
                if (options.isOnlyShowBar) {
                    options.callBack && options.callBack(percentage, this);
                }
            },
        },
    },
    methods: {
        init() {
            this.dialogVisible = false;
            this.progressData.taskId = '';
            this.progressData.title = '';
            this.progressData.percentage = 0;
            this.progressData.state = 0;
            this.progressData.message = '';
            this.progressData.btnArr = [];
            this.progressData.progeressText = '条产品';
            this.taskName = '';
            this.completeCount = 0;
            this.totalCount = 0;
            customBtn = false;
        },
        setloopTimeout() {
            if (loopTimeout) {
                clearTimeout(loopTimeout);
            }
            loopTimeout = setTimeout(
                this.loopFn,
                window.DZ_CONFIGURE ? window.DZ_CONFIGURE.PROGRESS_POLLING_TIME : 5000
            );
        },
        loopFn() {
            const taskId = this.progressData.taskId;
            if (!taskId || !this.isOpen) {
                if (loopTimeout) {
                    clearTimeout(loopTimeout);
                }
                return;
            }
            this.$ajax
                .post('https://api.fjdaze.com/taskManager/api/Task/TaskInfo/GetProgressInfo', {
                    taskId,
                })
                .then((res) => {
                    if (res.code !== 200) {
                        this.$message.warning(res.msg);
                        loading.close();
                        return;
                    }
                    const data = {
                        CompleteCount: res.result.completeCount,
                        Progress: res.result.progress,
                        TaskId: res.result.taskId,
                        TaskName: res.result.taskName,
                        TaskState: res.result.taskState,
                        TotalCount: res.result.totalCount,
                    };
                    this.handleData(data);
                    this.setloopTimeout();
                })
                .catch(() => {
                    this.setloopTimeout();
                });
        },
        startDazeTask(taskId) {
            this.progressData.taskId = taskId;
            // dazeTask.login(taskId);
            this.setloopTimeout();
            dazeTask.register(taskId, (data) => {
                // data 可能是新的数据格式或者是旧的数据格式
                // data = { // 新的
                //   ExecutedCount: 42,
                //   Progress: 84,
                //   TaskId: "0a8b54ec07804a94bee01e811df1904d",
                //   TaskName: "批量修改产品标题",
                //   TaskState: 1,
                //   TotalCount: 50,
                // }
                // data = { // 旧的
                //   BeginTime: "2021-08-28T16:01:54.5519242+08:00",
                //   BusId: null,
                //   CompleteTime: "0001-01-01T00:00:00",
                //   CreateTime: "2021-08-28T16:01:54",
                //   CustomerId: "b2b-1624961198",
                //   IsSuccess: false,
                //   Message: "正在批量修改产品标题:26/50条产品",
                //   Name: "批量修改产品标题2021-08-28 16:01:54",
                //   Progress: 70,
                //   Result: null,
                //   State: 1,
                //   Tag: "批量修改产品标题",
                //   TaskId: "0a8b54ec07804a94bee01e811df1904d"
                // }
                if (!this.isOpen) {
                    return;
                } // 不接受消息
                this.setloopTimeout();
                this.handleData(data);
            });
        },
        handleData(data) {
            if (!this.isOpen) {
                return;
            }
            this.dialogVisible = true;
            loading.close();
            const isNewData = Object.prototype.hasOwnProperty.call(data, 'TaskState'); // 是否为新的数据格式
            const state = isNewData ? data.TaskState : data.State;
            // 当前推送过来的状态 为0的时候 验证 进度条的状态如果不为0 那么这条消息推送就作废
            if (this.progressData.state != 0 && state == 0) {
                return;
            }
            this.progressData.state = state;

            if (isNewData) {
                const { CompleteCount, TotalCount } = data;
                const totalCount = TotalCount > this.totalCount ? TotalCount : this.totalCount;
                this.totalCount = totalCount;
                let completeCount = CompleteCount > this.completeCount ? CompleteCount : this.completeCount;
                if (completeCount > totalCount) {
                    completeCount = totalCount; // 完成条数可能大于总条数
                }
                this.completeCount = completeCount;
                this.progressData.message = `正在${data.TaskName}:${completeCount}/${totalCount}${this.progressData.progeressText}`;
            } else {
                this.progressData.message = data.Message;
            }
            if (state === 2 || state === 3) {
                // 2:已完成    3:已取消
                // if (!data.hasOwnProperty("TaskState")) return; // 新的数据结构才有 TaskState
                this.isOpen = false;
                if (state === 2) {
                    this.progressData.percentage = 100;
                }
                const taskId = this.progressData.taskId;
                // this.progressData.taskId = "";

                let getResultTimeout = setTimeout(() => {
                    this.$ajax
                        .post('api/tiktok/ForbiddenWordRecord/SearchTaskLog', {
                            TaskId: taskId,
                            TaskLogTypes: options.taskLogTypes, // -1 代表失败的数据
                            PageIndex: 1,
                            PageSize: 500, // 上下架最多展示500条
                        })
                        .then((res) => {
                            clearTimeout(getResultTimeout);
                            let result;
                            if (res && res.result.list && res.result.list.length) {
                                result = {
                                    Data: res.result.list,
                                    TotalCount: res.totalCount,
                                    succTotalCount: res.succTotalCount,
                                    failTotalCount: res.failTotalCount,
                                };
                            } else {
                                result = {
                                    Data: [],
                                    TotalCount: res.totalCount,
                                    succTotalCount: res.succTotalCount,
                                    failTotalCount: res.failTotalCount,
                                };
                            }
                            options.callBack(result, { taskId });
                            this.dialogVisible = false;
                        })
                        .catch((err) => {
                            this.$message.error(err || '获取任务结果失败，请重试');
                            clearTimeout(getResultTimeout);
                            this.dialogVisible = false;
                            // if (this.progressData.taskId === "") return;
                            // options.callBack({
                            //   Data: [],
                            //   TotalCount: 0,
                            // });
                        });
                }, 1000);
                return;
            }
            if (this.progressData.isFake) {
                // 假的进度条
                if (data.Progress >= 100) {
                    this.progressData.percentage = 100;
                } else if (this.progressData.percentage >= 90) {
                    this.progressData.percentage = 99;
                } else {
                    this.progressData.percentage += this.progressData.speed;
                }
            } else {
                this.progressData.percentage =
                    data.Progress >= 100
                        ? 100
                        : data.Progress > this.progressData.percentage
                        ? data.Progress
                        : this.progressData.percentage;
            }
        },
        btnHanle(item) {
            console.log(item.callback);
            if (!customBtn) {
                this.btnClick(item);
                return;
            }
            this.isOpen = false;
            if (item.autoClose == undefined || item.autoClose) {
                this.dialogVisible = false;
            }
            item.callback && item.callback(this);
        },
        btnClick(item) {
            if (item.key === 'cancel') {
                const that = this;
                this.$confirm(item.cancelTip, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    type: 'warning',
                })
                    .then(() => {
                        item.brforeCancel && item.brforeCancel();
                        that.$ajax
                            .post('api/tiktok/Task/cancel', {
                                taskId: that.progressData.taskId,
                            })
                            .then((res) => {
                                if (res.code === 200) {
                                    that.$message.success(item.cancelSuccessTip || '取消成功!');
                                    that.btnCallBack(item);
                                } else {
                                    // throw Error(res.msg || "取消失败");
                                    that.$message.warning(res.msg || '取消失败');
                                }
                            })
                            .catch((err) => {
                                that.$message.error(err);
                            });
                    })
                    .catch(() => {});
            } else {
                this.btnCallBack(item);
            }
        },
        btnCallBack(item) {
            const taskId = this.progressData.taskId;
            this.isOpen = false;
            this.dialogVisible = false;
            item.callback && item.callback(taskId);
            dazeTask.remove(taskId);
        },
        // eslint-disable-next-line max-lines-per-function
        show(_options) {
            options = {
                percentage: 0,
                title: '进度',
                text: '数据加载中',
                url: '',
                taskId: '',
                taskName: '正在修改中',
                data: {},
                btns: null,
                taskLogTypes: [-1],
                isOnlyShowBar: false, // 是否展示纯净度
                callBack: undefined,
            };
            options = Object.assign(options, _options);
            this.init();
            if (options.progeressText) {
                this.progressData.progeressText = options.progeressText;
            }
            const btns = [];
            if (options.showCancelBtn) {
                btns.push({
                    name: '取 消',
                    type: '',
                    key: 'cancel',
                    cancelTip: options.cancelTip || '是否确认要取消任务？',
                    cancelSuccessTip: options.cancelSuccessTip || '取消成功!',
                    brforeCancel: options.brforeCancel || null,
                    callback: options.cancelCallback || null,
                });
            }
            if (options.showRunInBgBtn) {
                btns.push({
                    name: '后台运行',
                    type: 'primary',
                    key: 'runInBg',
                    callback: null,
                });
            }
            if (options.btns) {
                customBtn = true;
            }
            this.progressData.title = options.title;
            this.progressData.text = options.text;
            this.progressData.btnArr = options.btns || btns;
            this.progressData.percentage = options.percentage;
            this.progressData.state = 0;
            this.progressData.isFake = !!options.isFake;
            this.progressData.speed = options.speed || 15;
            this.progressData.taskName = options.taskName;
            this.isOpen = true;
            if (options.isOnlyShowBar) {
                this.dialogVisible = true;
                return;
            }
            loading = this.$loading({
                fullscreen: true,
                text: options.text,
                background: 'rgba(0, 0, 0, 0.1)',
            });
            if (options.taskId !== '') {
                this.progressData.taskId = options.taskId;
                this.startDazeTask(options.taskId);
                return;
            }
            let headers = {};
            const url = options.url;
            const data = options.data;
            if (url === 'XxlJobTaskPublishManager/api/BatchModify/Product/TaskPublish') {
                const encryptionData = cloneDeep(JSON.parse(data.Param));
                try {
                    // 入参加密
                    const { rc, rs, rd } = encryption(JSON.stringify(cloneDeep(encryptionData)));
                    headers = { rc, rs, rd };
                } catch (err) {
                    // do err
                }
            }

            this.$ajax
                .post(url, data, {
                    headers,
                })
                .then((getTaskId) => {
                    // if (getTaskId.hasOwnProperty("Success") && getTaskId.Success === false) {
                    //   loading.close();
                    //   this.$message.warning(getTaskId.Tips || "创建任务失败");
                    //   return;
                    // }
                    var message = getTaskId.msg || getTaskId.Msg;
                    var code = getTaskId.code || getTaskId.Code;
                    var result = getTaskId.result || getTaskId.Result;
                    const isString = typeof result === 'string';
                    const taskId = isString ? result : result.TaskId || result.taskId;
                    this.progressData.taskId = taskId;
                    if (code == 200) {
                        if (!isString) {
                            if ([0, 1].includes(result.taskState)) {
                                loading.close();
                                this.progressData.state = result.taskState;
                                this.progressData.percentage = result.progress;
                                const completeCount =
                                    result.completeCount > result.totalCount ? result.totalCount : result.completeCount; // 完成条数可能大于总条数
                                this.progressData.message = `正在${result.taskName || ''}:${completeCount}/${
                                    result.totalCount
                                }${this.progressData.progeressText}`;
                                this.dialogVisible = true;
                                this.startDazeTask(taskId);
                            } else {
                                this.startDazeTask(taskId);
                            }
                        } else {
                            // 正常执行任务
                            this.startDazeTask(taskId);
                        }
                    } else if (code == 999) {
                        loading.close();
                        this.$message({
                            message: message,
                            type: 'warning',
                        });

                        setTimeout(() => {
                            this.dialogVisible = true;
                            // this.dialogVisible = false;
                            this.startDazeTask(taskId);
                        }, 3000);
                    } else {
                        loading.close();
                        this.$message({
                            message: message,
                            type: 'warning',
                        });
                    }
                })
                .catch(() => {
                    loading.close();
                });
        },
        close() {
            this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
.custom {
    span {
        display: block;
        max-width: 100%;
        color: #444;
        word-break: break-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.colorff {
    color: #fff;
}
.progressTitle {
    font-size: 16px;
    font-weight: 400;
}
</style>
